import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { CATEGORY_CODES } from '_constants/categories';
import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';
import { selectError, selectLoading, selectPasswordSetStatus } from '_store/user/selector';
import { setPassword } from '_store/user/slice';

import { ReactComponent as LogoSvg } from 'assets/images/lumen-logo-dark.svg';

import SetPasswordForm from 'components/features/auth/SetPasswordForm';
import Card from 'components/shared/layouts/Card';

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: ${theme.spaces.regular}px;
  background-color: ${hexToRGBA(theme.colors.cyanBlue, 0.08)};
`;

const StyledInnerContainer = styled.div`
  max-width: 480px;
  width: 100%;
`;

const StyledLogoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${theme.spaces.largeX}px;
`;

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const success = useSelector(selectPasswordSetStatus);
  const error = useSelector(selectError);

  const handleSubmit = (values) => {
    const token = searchParams.get('token');

    if (values && token) {
      const { newPassword } = values;
      dispatch(setPassword({ token, password: newPassword, category: CATEGORY_CODES.main }));
    }
  };

  useEffect(() => {
    if (success) {
      navigate('/login');
    }
  }, [success]);

  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <Card>
          <StyledLogoContainer>
            <LogoSvg />
          </StyledLogoContainer>
          <SetPasswordForm loading={loading} error={error} onSubmit={handleSubmit} />
        </Card>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default ResetPasswordPage;
